import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Boot-/Wartungs-Screen entfernen, sobald die App-JS erfolgreich geladen und gerendert hat.
// (Wenn diese Datei fehlt, wird __appReady nie aufgerufen und der Wartungs-Screen bleibt stehen.)
try { if (window.__appReady) window.__appReady(); } catch (e) {}
